import { useContext, useState, useEffect } from 'react';
import { appStore } from 'store/app';

const useOutOfStock = () => {
  const [{ customData }] = useContext(appStore);
  const [isOutOfStock, setIsOutOfStock] = useState(false);
  const [outOfStockItems, setOutOfStockItems] = useState([]);

  let hasBoots = false;
  if (customData.bootsList) {
    hasBoots = true;
  }

  const sizeId = customData.bottle.size;
 
  useEffect(() => {
    // ボトルが在庫なし、かつ販売を継続しない場合はtrue
    const isOutOfStockBottle = customData.bottle.inventory_quantity <= 0 && customData.bottle.inventory_policy === "deny";

    // パーツに一つでも「在庫なしかつ販売を継続しない」ものがあればtrue
    let outOfStockParts = customData.partsList.filter(
      (item) => item.inventory_quantity <= 0 && item.inventory_policy === "deny"
    )

    const isOutOfStockParts = outOfStockParts.length > 0;

    let isOutofStockBoots = false;
    if (hasBoots) {
      const selectedBoot = customData.bootsList[0].variants[sizeId];
      isOutofStockBoots = Number(selectedBoot.inventory_quantity) <= 0 && selectedBoot.inventory_policy === "deny"
    }

    // ボトルとパーツにどちらかに在庫なしがあれば、在庫なし設定
    const state = isOutOfStockBottle || isOutOfStockParts || isOutofStockBoots;

    setIsOutOfStock(state);

    // 在庫なし商品
    const items = [];

    if (isOutOfStockBottle) {
      items.push(customData.bottle.name);
    }

    if (isOutOfStockParts) {
      customData.partsList.forEach((item) => {
        if (!item.available) {
          items.push(item.name);
        }
      });
    }

    setOutOfStockItems(items);
  }, [customData]);

  return [isOutOfStock, outOfStockItems];
};

export default useOutOfStock;
